var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 10065140
  }, /*#__PURE__*/React.createElement("g", {
    id: "_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6706 3.84949H17.4276V3.38649C17.4276 2.30049 16.5441 1.41699 15.4581 1.41699H9.54061C8.45461 1.41699 7.57111 2.30049 7.57111 3.38649V3.84949H4.32811C3.47861 3.84949 2.78711 4.54074 2.78711 5.39024V6.12074C2.78711 6.91599 3.39286 7.57224 4.16686 7.65324L5.75361 21.5772C5.90486 22.907 7.02861 23.9097 8.36711 23.9097H16.6314C17.9699 23.9097 19.0936 22.907 19.2449 21.5772L20.8316 7.65324C21.6059 7.57249 22.2114 6.91599 22.2114 6.12074V5.39024C22.2114 4.54074 21.5201 3.84949 20.6706 3.84949ZM8.57136 3.38649C8.57136 2.85174 9.00611 2.41699 9.54086 2.41699H15.4584C15.9931 2.41699 16.4279 2.85174 16.4279 3.38649V3.84949H8.57136V3.38649ZM18.2516 21.464C18.1579 22.2882 17.4614 22.9097 16.6319 22.9097H8.36761C7.53811 22.9097 6.84161 22.2882 6.74786 21.464L5.17511 7.66174H19.8246L18.2516 21.464ZM21.2119 6.12074C21.2119 6.41899 20.9691 6.66174 20.6709 6.66174H4.32811C4.02986 6.66174 3.78711 6.41899 3.78711 6.12074V5.39024C3.78711 5.09224 4.02986 4.84949 4.32811 4.84949H20.6704C20.9686 4.84949 21.2114 5.09224 21.2114 5.39024V6.12074H21.2119Z",
    fill: "#D81B39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 20.2034C12.776 20.2034 13 19.9794 13 19.7034V10.8679C13 10.5919 12.776 10.3679 12.5 10.3679C12.224 10.3679 12 10.5919 12 10.8679V19.7034C12 19.9794 12.224 20.2034 12.5 20.2034Z",
    fill: "#D81B39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4887 20.1803C15.5052 20.1821 15.5217 20.1828 15.5377 20.1828C15.7922 20.1828 16.0097 19.9898 16.0347 19.7313L16.8912 10.9373C16.918 10.6623 16.717 10.4178 16.4422 10.3911C16.1635 10.3628 15.9227 10.5653 15.896 10.8401L15.0395 19.6341C15.0127 19.9091 15.214 20.1536 15.4887 20.1803Z",
    fill: "#D81B39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.46161 20.1828C9.47761 20.1828 9.49411 20.182 9.51061 20.1803C9.78536 20.1538 9.98636 19.909 9.95961 19.634L9.10311 10.84C9.07636 10.5653 8.83561 10.363 8.55686 10.391C8.28211 10.4175 8.08111 10.6623 8.10786 10.9373L8.96436 19.7313C8.98961 19.9895 9.20736 20.1828 9.46161 20.1828Z",
    fill: "#D81B39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f085e079ce4bca0b3034bb7db1b95405.svg";
export { ForwardRef as ReactComponent };